import { GallerySearchMode } from '../models/gallery-search-mode.enum';
import { GalleryViewMode } from '../models/gallery-view-mode.enum';
import { StudioOptionsModel } from '../models/studio-options.model';
import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';
import { BookmarkSortModel } from 'src/app/bookmarks/models/bookmark-sort.model';

export class GalleryStateModel {
    loading: boolean;
    searchMode: GallerySearchMode;
    viewMode: GalleryViewMode;
    
    sort: BookmarkSortModel;
    sortOptions: BookmarkSortModel[];

    studioQuery: string;
    studioCategoryId: string;

    studioOptions: StudioOptionsModel[];
    searchResults: BookmarkModel[];

    checkedResults: string[];
}
